import styled from '@emotion/styled';

export const TableContainerComponent = styled.div`
  overflow: auto;
  margin: 20px 0;
  table {
    border-collapse: collapse;
    border: 1px solid #ddd;
    width: 100%;
  }
`;
